// eslint-disable-next-line
import tw, { css } from "twin.macro";
import { GrInstagram, GrLinkedinOption } from "react-icons/gr";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const LinkStyle = css`
  ${tw`text-red-600`}
`;

const ProfileCard = ({ name, designation, contactLink, avatarImage }) => {
  const image = getImage(avatarImage);

  return (
    <div tw="shadow-lg space-y-4 p-8 rounded-tr-3xl rounded-bl-3xl   bg-gray-700  text-white! border-l-0 border-r-0 border-b-0  	border-white border-solid hover:(shadow-2xl border-t-2  border-solid) transition-all duration-200 ease-in-out text-center hover:(transform scale-105)">
      {/* <img tw="rounded-full h-40 w-40" src={img} alt="profile" /> */}
      {/* <StaticImage src="../../images/aman.jpg" alt="A dinosaur" /> */}
      <GatsbyImage tw="rounded-full h-40 w-40" image={image} alt="profile" />

      <p tw="font-bold text-2xl">{name}</p>
      <p tw="text-xl text-gray-400">{designation}</p>

      <div tw="flex space-x-2 justify-center">
        <a href={contactLink.linkedIn}>
          <GrLinkedinOption css={LinkStyle} />
        </a>
        {contactLink.instgram && (
          <a href={contactLink.instgram}>
            <GrInstagram css={LinkStyle} />
          </a>
        )}
      </div>
    </div>
  );
};

export default ProfileCard;
